export default __webpack_public_path__ + "static/media/video-img.e2347a44.png";